// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.airport-selector {
  position: relative;
  width: 100%;
}

.airport-selector-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 8px;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  z-index: 50;
  max-height: 320px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.airport-selector-dropdown input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.airport-selector-dropdown input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.airport-selector-dropdown > div:last-child {
  overflow-y: auto;
  flex: 1 1;
}

/* Scrollbar styling */
.airport-selector-dropdown > div:last-child::-webkit-scrollbar {
  width: 6px;
}

.airport-selector-dropdown > div:last-child::-webkit-scrollbar-track {
  background: #f3f4f6;
}

.airport-selector-dropdown > div:last-child::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.airport-selector-dropdown > div:last-child::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}
`, "",{"version":3,"sources":["webpack://./src/components/AirportSelector.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".airport-selector {\n  position: relative;\n  width: 100%;\n}\n\n.airport-selector-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 8px;\n  background-color: white;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  z-index: 50;\n  max-height: 320px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.airport-selector-dropdown input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.airport-selector-dropdown input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.airport-selector-dropdown > div:last-child {\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Scrollbar styling */\n.airport-selector-dropdown > div:last-child::-webkit-scrollbar {\n  width: 6px;\n}\n\n.airport-selector-dropdown > div:last-child::-webkit-scrollbar-track {\n  background: #f3f4f6;\n}\n\n.airport-selector-dropdown > div:last-child::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 3px;\n}\n\n.airport-selector-dropdown > div:last-child::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
